import LoginPage from './Login';
import ResetPasswordPage from './ResetPassword';
import RenewPasswordPage from './RenewPassword';
import ConfirmPage from './Confirm';

export default [
  {
    name: 'Login',
    path: '/',
    exact: true,
    component: LoginPage,
  },
  {
    name: 'Reset password',
    path: '/reset-password',
    component: ResetPasswordPage,
  },
  {
    name: 'Renew password',
    path: '/renew-password',
    component: RenewPasswordPage,
  },
  {
    name: 'Confirm account',
    path: '/confirmation',
    component: ConfirmPage,
  },
];
